import styled from "@emotion/styled";
import {PropsWithChildren} from "react";

const Container = styled.div`
  border: 0;
  padding: 10px;
  position: absolute;
  top: 60px;
  bottom: 0;
  right: 0;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

export type OpsModeFilterPanelContainerProps = {}

export const OpsModeFilterPanelContainer = (props: PropsWithChildren<OpsModeFilterPanelContainerProps>) => {
  const {children} = props;

  return (
    <Container>
      <>
        {children}
      </>
    </Container>
  )
}
